// extracted by mini-css-extract-plugin
export default {"container":"video_container__tdjSE","card":"video_card__qGtxT","badge":"video_badge__5w-UD","link":"video_link__a+K5T","img":"video_img__GHT7s","playIcon":"video_playIcon__Krnvm"};